import { render, staticRenderFns } from "./addphoto.vue?vue&type=template&id=397230f4&scoped=true&"
import script from "./addphoto.vue?vue&type=script&lang=js&"
export * from "./addphoto.vue?vue&type=script&lang=js&"
import style0 from "./addphoto.vue?vue&type=style&index=0&id=397230f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397230f4",
  null
  
)

export default component.exports